import React from "react";
import ContactUs from "./ContactUs";
import "./Marketing.css";
import DigitalPDF from "../assets/Digital Marketing  - Codex Future Syllabus.pdf";
const Marketing = () => {
  return (
    <>
      

      <section className="marketing-section">
        <div className="marketing-container">
          <h1 className="marketing-title">100% Job Guarantee Digital Marketing Course</h1>
          <h3 className="marketing-subtitle">Online & Classroom Available*</h3>
          <p className="marketing-rating">(4.8 Reviews)</p>
          <p className="marketing-duration">Duration: 3 to 4 Months | 15+ Guaranteed Interviews</p>

          <p className="marketing-description">
            Welcome to <strong>Codex Future</strong>, where we provide training that upskills you. Our industry-experienced mentors
            will help you embrace future challenges and excel in your career with confidence.
          </p>

          <button className="marketing-btn" 
             onClick={() => window.open(DigitalPDF, "_blank")}>
            📘 Download Syllabus</button>

          <h2 className="marketing-heading">
            Digital Marketing Courses in Indore for Students, Professionals, Job Seekers & Business Owners
          </h2>
          <p className="marketing-text">
            Our classroom training program will take you from the fundamentals to the advanced levels of
            Digital Marketing. We cover all aspects such as <strong>SEO</strong>, <strong>Social Media</strong>,
            <strong> Google Ads</strong>, <strong>Affiliate Marketing/AdSense</strong>, <strong>YouTube Marketing</strong>, and
            <strong> Email Marketing</strong>.
          </p>

          <h2 className="marketing-heading">Job Seekers</h2>
          <p className="marketing-text">
            The field of Digital Marketing offers tremendous growth opportunities. According to Times of India,
            this industry will create over <strong>2.5 lakh jobs</strong> in the next few years. Join Codex Future —
            the best Digital Marketing Institute in Indore — and start building your dream career today!
          </p>

          <h2 className="marketing-heading">Working Professionals</h2>
          <p className="marketing-text">
            If you’re looking to make a career shift or upskill yourself with creative and high-demand expertise,
            this course is perfect for you. Enroll in <strong>Codex Future’s Digital Marketing Classes in Indore</strong>
            and unlock new opportunities in your professional journey.
          </p>

          <h2 className="marketing-heading">Students / Freshers & Graduates</h2>
          <p className="marketing-text">
            If you’ve recently graduated or are still pursuing your education, Digital Marketing can be your gateway
            to a vibrant and creative career. Our course is designed to equip you with modern marketing tools and
            strategies to stand out in today’s competitive job market.
          </p>

          <h2 className="marketing-heading">Entrepreneurs & Business Owners</h2>
          <p className="marketing-text">
            As a business owner, learning Digital Marketing helps you expand your reach and target the right audience.
            This course will empower you to manage and grow your company’s digital presence effectively using practical
            strategies and proven techniques.
          </p>
        </div>
      </section>

      <ContactUs />
      
    </>
  );
};

export default Marketing;
